"use strict";
//import smoothscroll from "smoothscroll-polyfill";
import { addEvent } from "./addEvent/addEvent";
import { isMobile } from "./isMobile/isMobile";
import { mobileMenu } from "./mobileMenu/mobileMenu";
import { mainPageBaner } from "./mainPageBaner/mainPageBaner";
import { backgroundPhotoSlider } from "./backgroundPhotoSlider/backgroundPhotoSlider";
import { filter } from "./filter/filter";
import "./colorbox/jquery.colorbox-min.js?";
import "./colorbox/colorbox.scss";
// import { scrollToElementIfVisble } from "./scrollToElement/scrollToElement";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: true });
  },
};

// loadingStart();
//smoothscroll.polyfill();
var mobileM = false;

document.addEventListener("DOMContentLoaded", DOMContentLoadedStart);
addEvent(window, "load", function () {
  afterLoadStart();
  powieksz_zdjecie();
  target_blank();
  filter();
  if (isMobile()) {
    $("body").addClass("mobile");
  }
});

addEvent(window, "resize", function () {
  resize();
});

addEvent(window, "scroll", function () {
  scroll();
});

/*----- START FUNCTION -----*/
function DOMContentLoadedStart() {
  mobileMenuInit();
}

function afterLoadStart() {
  mainPageBanerInit();
  backgroundPhotoSlideInit();
  //addVideoToPage();
}

function resize() {
  showHeaderBackground();
}

function scroll() {
  showHeaderBackground();
}

/*----- CODE BELOW -----*/
function target_blank() {
  $("a.out").attr("target", "blank");
}

function powieksz_zdjecie() {
  const tab = $("a.powieksz");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.powieksz").colorbox({
      initialWidth: 156,
      initialHeight: 80,
      maxWidth: "95%",
      maxHeight: "90%",
      scrolling: false,
      onComplete: function () {
        var $title = $(this).attr("title");
        $("body").find("img.cboxPhoto").attr("alt", $title);
      },
    });
  }
}

function mainPageBanerInit() {
  const banerTxt = document.getElementById("main-page-baner-container");
  if (banerTxt) {
    new mainPageBaner(banerTxt);
  }
}

function addVideoToPage() {
  if (isMobile()) {
    return false;
  }
  const videoContainers = document.getElementsByClassName("load-video");

  for (let i = 0; i < videoContainers.length; i++) {
    if (!videoContainers[i].hasAttribute("data-videosrc")) {
      continue;
    }
    let videosrc = videoContainers[i].getAttribute("data-videosrc");
    if (!videosrc) {
      continue;
    }

    let video = document.createElement("video");
    video.classList.add("video-bg__video");
    video.loop = true;
    video.muted = true;
    video.autoplay = true;

    if (video.canPlayType("video/mp4").length > 0) {
      video.src = videosrc;
    } else {
      continue;
    }
    videoContainers[i].appendChild(video);
  }
}

function backgroundPhotoSlideInit() {
  const elements = document.querySelectorAll(".background-photo-slider");
  elements.forEach((element) => {
    new backgroundPhotoSlider(element);
  });
}

function mobileMenuInit() {
  mobileM = new mobileMenu();
}

function showHeaderBackground() {
  const className = "page-scrolled";
  const showZone = document.getElementsByClassName(className);
  if (showZone.length == 0) {
    //return false;
  }

  let scroll = $(window).scrollTop();

  //if (scroll >= Math.max(window.innerHeight / 5, 100)) {
  if (scroll >= 50) {
    document.body.classList.add(className);
  } else {
    document.body.classList.remove(className);
  }
}
